import { call, select, put } from 'redux-saga/effects';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';
import { redeemCampaign as redeemCampaignBit } from '../bitSagas/redeemCampaign';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import getCustomerInfo from '@gcloud-npm/adabyron.abs-layer.client.customer-info';
import { normalizeCustomerInfo } from "@gcloud-npm/normalizers.adabyron.abs-layer.customer-info";
import LocalStorageLib from '@gcloud-npm/utils.secure.local-storage';
import { STRING_KEYS } from '../localizedStrings';

const uiNeedsStore = (state) => state.uiNeeds;
const flowStore = state => state.flow;
const contextStore = state => state.context.data;
const localizedStringsStore = state => state.localizedStrings;

export function* redeemCampaignAction() {

  const { clientWithoutAvailableCredit, clientWithDebt, clientWithUnknownRisk, confirmationInfo } = yield select(uiNeedsStore);
  const { localizedStrings } = yield select(localizedStringsStore);

  if (clientWithDebt || clientWithUnknownRisk || clientWithoutAvailableCredit) {
    return null;
  }

  const token = yield call(grecaptcha.enterprise.execute, RECAPTCHA_SITE_KEY, {
    action: 'order_tracking_client',
  });

  const redeemCampaignParams = {
    campaignId: localizedStrings[STRING_KEYS.campaignCode],
    transactionId: confirmationInfo.idCO || confirmationInfo.idSE || "-1",
    token,
  };

  try {
    const response = yield call(redeemCampaignBit, redeemCampaignParams);
    
    try {
      const context = yield select(contextStore);

      const getCustomerInfoResponse = yield call(getCustomerInfo, { context });

      const { userCompatibilities, customer } = normalizeCustomerInfo(getCustomerInfoResponse);

      const localStorageLib = new LocalStorageLib();
      let persistedInfo = localStorageLib.getItem("ts");
      persistedInfo = {
        ...persistedInfo,
        userCompatibilities,
        customer
      };
      localStorageLib.setItem("ts", persistedInfo);
    } catch (e) {
      console.log(e);
    }
    return response;
  } catch (error) {
    const errorResponse = megaMinderStatus.OK;
    errorResponse.errorInfo = error;

    return errorResponse;
  }
}

const validateCaptcha = () => {
  return new Promise((res) => {
    grecaptcha.enterprise.ready(() => {
      return res();
    });
  });
};

export function* redeemCampaign(params) {

  const { flowJson } = yield select(flowStore);

  if(flowJson?.callRedeemCampaign){
    yield put(loaderControlActions.setLoaderState({ loading: true }));

    const { showError, normalizeHttpErrors } = params;
    const reduxUpdate = { errorUpdate: showError };

    if (grecaptcha && grecaptcha.enterprise) {
      try {
        yield validateCaptcha();
        yield call(redeemCampaignAction, {
          normalizeHttpErrors,
          reduxUpdate,
        });

      } catch (error) {
        console.log(`Error sending redeemCampaign action: ${error}`);
      }
    }
  }
}
